// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AudioList--1qDVM>div{height:40px;padding:0}.AudioList--1qDVM svg{width:20px}", ""]);
// Exports
exports.locals = {
	"AudioList": "AudioList--1qDVM"
};
module.exports = exports;
